module.exports = __webpack_public_path__ + "static/img/js-logo.d8337bf3.png";